import { render, staticRenderFns } from "./ModalAnswersReplacement.vue?vue&type=template&id=69aa4d6a"
import script from "./ModalAnswersReplacement.vue?vue&type=script&lang=js"
export * from "./ModalAnswersReplacement.vue?vue&type=script&lang=js"
import style0 from "./ModalAnswersReplacement.vue?vue&type=style&index=0&id=69aa4d6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports